import React, { useEffect, useState } from 'react';
import './Hero.css';
import { FaArrowRight, FaHospital, FaChartLine, FaUsers } from 'react-icons/fa';

const Hero = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero">
      <div className="hero-background">
        <div className="hero-shape shape-1"></div>
        <div className="hero-shape shape-2"></div>
        <div className="hero-shape shape-3"></div>
      </div>

      <div className={`hero-container container ${isVisible ? 'visible' : ''}`}>
        <div className="hero-content">
          <div className="hero-badge">
            <span>🏥 Healthcare Technology Leaders</span>
          </div>
          
          <h1 className="hero-title">
            Empowering Healthcare with
            <span className="gradient-text"> Cutting-Edge Technology</span>
          </h1>
          
          <p className="hero-description">
            Empowering healthcare institutions with innovative software solutions. 
            From full-scale HMS to efficient Queue Management, we drive operational excellence.
          </p>
          
          <div className="hero-buttons">
            <button className="btn-primary" onClick={scrollToContact}>
              Request Demo <FaArrowRight />
            </button>
            <button className="btn-secondary" onClick={() => document.getElementById('products').scrollIntoView({ behavior: 'smooth' })}>
              Explore Products
            </button>
          </div>

          <div className="hero-stats">
            <div className="stat-item">
              <FaHospital className="stat-icon" />
              <div className="stat-content">
                <h3>70+</h3>
                <p>Healthcare Clients</p>
              </div>
            </div>
            <div className="stat-item">
              <FaChartLine className="stat-icon" />
              <div className="stat-content">
                <h3>99.9%</h3>
                <p>Uptime Guarantee</p>
              </div>
            </div>
            <div className="stat-item">
              <FaUsers className="stat-icon" />
              <div className="stat-content">
                <h3>24/7</h3>
                <p>Expert Support</p>
              </div>
            </div>
          </div>
        </div>

        <div className="hero-image">
          <div className="hero-card card-1">
            <div className="card-icon">📊</div>
            <h4>Real-time Analytics</h4>
            <p>Monitor operations live</p>
          </div>
          <div className="hero-card card-2">
            <div className="card-icon">🔒</div>
            <h4>Secure & Compliant</h4>
            <p>NABH & JCI certified</p>
          </div>
          <div className="hero-card card-3">
            <div className="card-icon">⚡</div>
            <h4>Cloud-based</h4>
            <p>Access anywhere, anytime</p>
          </div>
          <div className="hero-illustration">
            <div className="illustration-circle"></div>
            <div className="illustration-dots"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
